// extracted by mini-css-extract-plugin
export default {"truncatedName":"fQ1HHZWBAH06NAlGweCd"};